<template>
  <div class="table__rows-container">
    <div
      v-for="item in data"
      :key="item.id"
      class="table__row"
      :class="rowClass"
    >
      <!-- 1 -->
      <div>
        <router-link class="link" :to="`/blocks/${item.block_number}`">
          {{ item.block_number.toLocaleString() }}
        </router-link>
      </div>

      <!-- 2 -->
      <div>
        <span>{{ item.timeDiff }}</span>
      </div>

      <!-- 3 -->
      <div>
        <span>
          {{ item.tx_count }}
        </span>
      </div>

      <!-- 4 -->
      <div>
        <router-link class="link" :to="`/blocks/${item.block_hash}`">
          {{ ellipsis(item.block_hash, 5) }}
        </router-link>
      </div>

      <!-- 5 -->
      <div>
        <span>{{ ellipsis(item.data_hash, 5) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ellipsis } from "../../../js/format";

export default {
  props: ["data", "rowClass"],
  methods: {
    ellipsis: ellipsis,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contents/shared/TableSlotBlockHome.vue